import { useMediaQuery } from 'react-responsive';
import { BREAKPOINT_SIZES } from 'tradera/constants/breakpoints';

const useIsMobile = () =>
    useMediaQuery({
        minWidth: BREAKPOINT_SIZES.XS.min,
        maxWidth: BREAKPOINT_SIZES.SM.max
    });

export default useIsMobile;
